/**
 * App configuration
 * - USE_DUMMY: true → dummy data, false → real API calls
 * - Controlled via REACT_APP_USE_DUMMY env variable
 */
const config = {
  USE_DUMMY: process.env.REACT_APP_USE_DUMMY === 'true',
  API_URL: process.env.REACT_APP_API_URL ?? 'http://localhost:8000',

  /** PortOne V2 결제 연동 */
  PORTONE_V2_STORE_ID: process.env.REACT_APP_PORTONE_V2_STORE_ID || '',
  PORTONE_CHANNEL_KEY: process.env.REACT_APP_PORTONE_CHANNEL_KEY || '',           // 국내(KG이니시스 등)
  PORTONE_PAYPAL_CHANNEL_KEY: process.env.REACT_APP_PORTONE_PAYPAL_CHANNEL_KEY || '', // 해외(PayPal)
  // 레거시 (V1 SDK 시절 호환용 — V2 전환 후 미사용. .env에 남아도 무방)
  PORTONE_IMP_CODE: process.env.REACT_APP_PORTONE_IMP_CODE || '',
  PORTONE_INICIS_MID: process.env.REACT_APP_PORTONE_INICIS_MID || '',

  /** 채널톡 — https://channel.io 가입 후 Plugin Key 입력 */
  CHANNEL_TALK_KEY: process.env.REACT_APP_CHANNEL_TALK_KEY || '',

  /** 카카오톡 채널 — 카카오 비즈니스에서 채널 URL 확인 */
  KAKAO_CHANNEL_URL: process.env.REACT_APP_KAKAO_CHANNEL_URL || '',

  /** 소셜 로그인 SDK 키 */
  KAKAO_APP_KEY: process.env.REACT_APP_KAKAO_APP_KEY || '',
  NAVER_CLIENT_ID: process.env.REACT_APP_NAVER_CLIENT_ID || '',
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',

  /** DeepL 번역 API — 카카오맵 검색 결과 다국어 변환 */
  DEEPL_API_KEY: process.env.REACT_APP_DEEPL_API_KEY || '',
  DEEPL_API_URL: process.env.REACT_APP_DEEPL_API_URL || 'https://api-free.deepl.com/v2/translate',
};

export default config;
